module.exports = __webpack_public_path__ + "img/icon-row.58d4ba0f.svg";